var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guidepage",style:({ background: _vm.pageBg })},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.pagebanner),expression:"pagebanner"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }